import React from "react";
import { Outlet } from "react-router-dom";

// import Footer from "../GuestPages/Footer";
import Nav from "../GuestPages/Nav";
// import Footer from "../GuestPages/Footer";
import styled from "styled-components";
import Footer from "../GuestPages/Footer";


const GeneralRap = styled.div`

`

export default function General () {
    return (
        <GeneralRap>
<Nav />
        <Outlet />
        <Footer />
        </GeneralRap>
    )
}